import React from 'react';

import { List, ListItem } from 'common/components/DropDownMenu/DropDownMenu.styled';
import { ItemModel } from 'common/components/DropDownMenu/ItemModel';

interface IContentProps {
  isVisible: boolean;
  items: ItemModel[];
  onOutsideClick: () => void;
  position?: string;
  notchPosition?: string;
}

export const MenuList = ({
  isVisible,
  items,
  onOutsideClick,
  position,
  notchPosition,
}: IContentProps) => {
  if (!isVisible) {
    return <></>;
  }

  return (
    <>
      <List
        $isVisible={isVisible}
        $position={position === 'top' ? 'top' : 'bottom'}
        notchPosition={notchPosition === 'left' ? 'left' : 'right'}
      >
        {items.map(({ label, onClick, isDisabled, icon, isOptionHidden, color }) => {
          if (isOptionHidden) return;

          return (
            <ListItem
              key={label}
              onClick={() => {
                if (isDisabled) return;
                onClick();
                onOutsideClick();
              }}
              disabled={isDisabled}
              style={{ color }}
            >
              {icon}
              {label}
            </ListItem>
          );
        })}
      </List>
    </>
  );
};
